import React, { useState, useEffect, useMemo } from 'react'
import './Sidebar.css'
import logo from '../../images/logos.svg';
import ProfileModal from '../Modal/ProfileModal';
import SidebarMenu from './SidebarMenu';
import { getBuildingAction, getBuildingTypeAction, getCityAction, getConstitutionAction, getDefaultGstAction, getDocNamesList, getElectricityConnectionAction, getHSNAction, getInvestorTypeAction, getLotIntentAction, getOnBasisAction, getPermissionTypeAction, getPocDesignation, getProfileImage, getProjectAction, getQueryAction, getResellReasonAction, getSendFromAction, getSoldGalaAction, getUserProjectAction, getVillagesAction, getWaterSupplyAction, loaderAction, loginAction, successModalToggle, UserDataAction, warningModalToggle, warningModalToggle2 } from '../../redux/actions/Index';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { environment } from '../../env';
import SidebarTooltip from './SidebarTooltip';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NavLink } from 'react-router-dom';
import { getGalaAction, getFloorTypeAction, getGSTAction } from './../../redux/actions/Index';
import { ArrowsClockwise } from '@phosphor-icons/react';
import { Label } from 'reactstrap';
import AsyncSelect from 'react-select/async';
import { useNavigate } from 'react-router-dom';
import WarningPopupActive from '../Popups/WarningPopupActive';
import { useLayoutEffect } from 'react';
import SidebarApi from './SidebarApi';

const Sidebar = ({ children }) => {
    const [isActive, setisActive] = useState(false);
    const [deActive, setdeActive] = useState(false);
    const dispatch = useDispatch();
    const userdata = useSelector((state) => state?.Reducers?.userdata);
    const userid = localStorage.getItem("userid")
    const asyncSelectRef = React.useRef(null);
    const userProject = useSelector((state) => state?.ModalReducer?.userproject);
    const navigate = useNavigate();
    const UserRegistration = async () => {
        try {
            await axios.get(`${environment.baseUrl}get-registration/${parseInt(userid)}`).then(res => {
                localStorage.setItem('is_active', res.data.is_active)
                dispatch(UserDataAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getProjectData = () => {
        try {
            axios.get(`${environment.baseUrl}project/`).then(res => {
                let data = res.data;
                dispatch(getProjectAction(data));

            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getUserProject = () => {
        try {
            axios.get(`${environment.baseUrl}user-project/${parseInt(userid)}`).then(res => {
                let data = res.data;
                dispatch(getUserProjectAction(data.project));
                dispatch(getProfileImage(data.profile_img));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getOnBasis = () => {
        try {
            axios.get(`${environment.baseUrl}onbasis/`).then(res => {
                let data = res.data;
                dispatch(getOnBasisAction(data));

            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getBuildingData = () => {
        try {
            axios.get(`${environment.baseUrl}building/`).then(res => {
                let data = res.data.filter((data, i) => data?.project.id == userProject)
                dispatch(getBuildingAction(data));

            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getGalaData = () => {
        let galaApi = "gala";
        localStorage.setItem(galaApi,true)
        try {
            axios.get(`${environment.baseUrl}gala/`).then(res => {
                let data = res.data.filter((data, i) => data?.project.id == userProject)
                dispatch(getGalaAction(data));
                localStorage.removeItem(galaApi);
            }).catch(res => {
                localStorage.removeItem(galaApi);
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getSoldGalaData = () => {
        let soldGalaApi = 'sold-gala'
        localStorage.setItem(soldGalaApi,true);
        try {
            axios.get(`${environment.baseUrl}sold-gala/`).then(res => {
                let data = res.data.filter((data, i) => data?.project.id == userProject)
                dispatch(getSoldGalaAction(data));
                localStorage.removeItem(soldGalaApi)
            }).catch(res => {
                localStorage.removeItem(soldGalaApi)
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getVillagesData = () => {
        try {
            axios.get(`${environment.baseUrl}village/`).then(res => {
                dispatch(getVillagesAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getResellReasonData = () => {
        try {
            axios.get(`${environment.baseUrl}resellreason/`).then(res => {
                dispatch(getResellReasonAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getInvestorType = () => {
        try {
            axios.get(`${environment.baseUrl}investor-type/`).then(res => {
                dispatch(getInvestorTypeAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getPermissionType = () => {
        try {
            axios.get(`${environment.baseUrl}permission-type/`).then(res => {
                dispatch(getPermissionTypeAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getElectricityConnection = () => {
        try {
            axios.get(`${environment.baseUrl}electric-connection/`).then(res => {
                dispatch(getElectricityConnectionAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getWaterSupply = () => {
        try {
            axios.get(`${environment.baseUrl}water-supply/`).then(res => {
                dispatch(getWaterSupplyAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const getCity = () => {
        try {
            axios.get(`${environment.baseUrl}city/`).then(res => {
                dispatch(getCityAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const getConstitution = () => {
        try {
            axios.get(`${environment.baseUrl}constitutions/`).then(res => {
                dispatch(getConstitutionAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getDocNames = () => {
        try {
            axios.get(`${environment.baseUrl}add-doc/`).then(res => {
                dispatch(getDocNamesList(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getBuildingTypes = () => {
        try {
            axios.get(`${environment.baseUrl}building-type/`).then(res => {
                dispatch(getBuildingTypeAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getFloorType = () => {
        try {
            axios.get(`${environment.baseUrl}floor-type/`).then(res => {
                dispatch(getFloorTypeAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const getLotIntent = () => {
        try {
            axios.get(`${environment.baseUrl}checked-intent/`).then(res => {
                dispatch(getLotIntentAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const getPOCDesignation = () => {
        try {
            axios.get(`${environment.baseUrl}poc-designation/`).then(res => {
                let data = res.data;
                dispatch(getPocDesignation(data));

            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const getSendFrom = () => {
        try {
          axios
            .get(`${environment.baseUrl}bill-send-from/`)
            .then((res) => {
                dispatch(getSendFromAction(res.data));
            })
            .catch((res) => {
              console.log("error");
            });
        } catch (err) {
          console.log(err);
        }
      };

    const getGST = () => {
        try {
            axios.get(`${environment.baseUrl}create-gst`).then(res => {
                dispatch(getGSTAction(res.data));
                res.data.map(data => {
                    if (data.default == true) {
                        dispatch(getDefaultGstAction(data.percentage))
                    }
                })
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getHsn = () => {
        try {
            axios.get(`${environment.baseUrl}create-hsn`).then(res => {
                dispatch(getHSNAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const getQuery = () => {
        try {
            axios.get(`${environment.baseUrl}query`).then(res => {
                let data = res.data.filter(data => data.gala_investor.project.id == userProject)
                dispatch(getQueryAction(data));

            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const pop = () => {
        if (userdata?.role !== "superadmin") {
            SidebarApi.pop()
        }
    }

    const handleReload = () => {
        getHsn();
        getGST();
        getGalaData();
        getSoldGalaData();
        getFloorType();
        UserRegistration();
        getProjectData();
        getQuery();
        getBuildingData();
        getVillagesData();
        pop()
        getResellReasonData();
        getPermissionType();
        getElectricityConnection();
        getPOCDesignation();
        getWaterSupply();
        getInvestorType();
        getCity();
        getConstitution();
        getDocNames();
        getBuildingTypes();
        getOnBasis();
        getLotIntent();
        getUserProject();
        getSendFrom();
        toast.success('Data Refresh Successfully !', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
        });
    }
    const is_active = localStorage.getItem('is_active')
    const userdeActive = () => {
        if (is_active == 'false') {
            dispatch(warningModalToggle2())
            logoutTime()
        }
    }
    useLayoutEffect(() => {
        // UserRegistration()
        if (is_active == 'false' && window.location.pathname != "/") {
            dispatch(warningModalToggle2())
        }
    }, [deActive])

    useMemo(() => {
        if(userProject != undefined){
            getBuildingData();
            getGST();
            getHsn();
            getGalaData();
            getSoldGalaData();
            getFloorType();
            getPOCDesignation();
            UserRegistration();
            getProjectData();
            getQuery();
            getVillagesData();
            getResellReasonData();
            getPermissionType();
            getElectricityConnection();
            getWaterSupply();
            getInvestorType();
            getCity();
            getConstitution();
            getDocNames();
            getBuildingTypes();
            getOnBasis();
            getLotIntent();
            getSendFrom();
            pop()
        }else{
            getUserProject();
        }
    }, [userProject]);


    const handleChange = (selectedOption) => {
        if (selectedOption) {
            navigate(selectedOption?.value)
        }
    };


    useEffect(() => {
        const handleCtrlV = (event) => {
            if (event.ctrlKey && event.key === 'x') {
                event.preventDefault();
                asyncSelectRef.current.focus();
                asyncSelectRef.current.openMenu('first');
            }
        };

        document.addEventListener('keydown', handleCtrlV);

        return () => {
            document.removeEventListener('keydown', handleCtrlV);
        };
    }, []);


    // user logout

    const logoutTime = () => {
        dispatch(loginAction(false))
        window.location.href = "/";
        localStorage.removeItem("userid")
    };


    return (
        <>
            <ToastContainer />
            <WarningPopupActive deleteData={userdeActive} />
            <div className="container-fluid d-flex justify-content-start p-0 ">
                <div className={`${isActive ? "header-position-active" : "header-position"}`}>
                    <div className={`header-bar gap-3 ${isActive && "header-bar-none"} position-sticky`}>
                        <span className="logo-fit">
                            <img src={logo} alt="logo" className="img-fit" />
                        </span>
                        <div className={`${isActive && "title-none"} text-start`}>
                            <NavLink to={"/"} className="border-none text-decoration-none" >
                                <h1 className={`mb-0 title-font-800 text-white fs- sidebar-text ${isActive && "title-none"}`}>SUMEET</h1>
                                <h6 className=" title-font-800 text-white fs-3">LOGISTICS</h6>
                            </NavLink>

                        </div>
                    </div>
                </div>
                <div className={`${isActive ? "sidebar-backdrop-none" : "sidebar-backdrop"}`} onClick={() => setisActive(!isActive)}></div>
                <div className={`${isActive ? "sidebars-active" : "sidebars "}`}>
                    <ul className="sidebar-container px-5 mt-3 d-flex justify-content-center align-items-center flex-column gap-4" onClick={() => setdeActive(!deActive)}>
                        {
                            SidebarApi.map((index, i) => {
                                if (index.childs) {
                                    return (
                                        <SidebarMenu key={i} id={i} index={index} isActive={isActive} />
                                    )
                                }
                                return (
                                    <SidebarTooltip key={i} index={index} id={i} isActive={isActive} />
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
            <div className="content">
                <div className={`${isActive ? "navbars-active" : "navbars "} px-5`}>
                    <div className="icon">
                        <button onClick={() => setisActive(!isActive)} className={`${isActive ? "hamburger-menu active" : "hamburger-menu "} `}>
                            <div className="bar mt-0"></div>
                            <div className="bar"></div>
                            <div className="bar"></div>
                        </button>
                    </div>
                    <div className="d-none d-md-flex justify-content-between align-items-center gap-5">
                        <NavLink className="px-3 py-2 btn fs-2 shadow-sm bg-white border" to="/Buildings">Create Building</NavLink>
                        <NavLink className="px-3 py-2 btn fs-2 shadow-sm bg-white border" to="/Investors">Create Investor</NavLink>
                        <NavLink className="px-3 py-2 btn fs-2 shadow-sm bg-white border" to="/Proposal">Create LOI</NavLink>
                        <NavLink className="px-3 py-2 btn fs-2 shadow-sm bg-white border" to="/TenantGala">Create Tenant</NavLink>
                    </div>
                    <div className="user d-flex justify-content-between align-items-center gap-2">

                        {
                            !userProject && <Label className='base-font-600 fw-600 fs-3 text-danger m-3'>
                                Please select default project in user profile !!!
                            </Label>
                        }
                        <button className=" bg-transparent pe-3 border-0" title='Reload' onClick={handleReload}>
                            <ArrowsClockwise size="36" />
                        </button>
                        <div className="name border-start ps-3">
                            <h4 className="title-font-600 text-capitalize">{userdata?.first_name} {userdata?.last_name}</h4>
                            <h5 className="mb-0 d-flex align-items-center justify-content-end  "><i className='bx bx-radio-circle-marked bx-flashing fs-2 text-base-green' ></i> <span className="title-font-600 text-base-gray fs-24">{userdata?.role == 'superadmin' && 'SuperAdmin' || userdata?.role == 'admin' && 'Admin' || userdata?.role == 'user' && 'user'}</span></h5>
                        </div>
                        <ProfileModal logoutTime={logoutTime} />
                    </div>
                </div>
                <main className={`${isActive ? "main-section-active" : "main-section "} pb-5`} >
                    {children}
                </main>
            </div>
        </>
    )
}

export default Sidebar